<script lang="ts">
  import '../../../app.postcss'
  import LaunchButton from './LaunchButton.svelte'
  export let nextPage: string = 'Contact'
  export let pageLink: string = '/'
  import SmallArrowUp from './SVGs/SmallArrowUp.svelte'
  import ButtonArrowUpSvg from './SVGs/ButtonArrowUpSVG.svelte'
  import ButaneImage from '$lib/components/ButaneImage.svelte'
  import { deferVideo } from '$lib/attachments/deferVideo'

  function handleContextMenu(event: Event): void {
    event.preventDefault()
  }
</script>

<footer class="mx-auto max-w-screen-xl-desktop">
  <div
    class="relative m-2 my-12 flex flex-col overflow-hidden rounded-lg border py-10 md:h-[850px] lg-tablet:h-[900px] lg:h-[830px] lg:space-y-24 lg-desktop:mx-4 lg-desktop:h-fit"
  >
    <div class="flex w-[80%] justify-between self-center lg:w-[95%]">
      <div class="flex flex-col space-y-0.5 text-[14px] uppercase lg:flex-row lg:items-baseline lg:space-x-4">
        <a href="/platform" class="flex min-h-6 items-center hover:underline"><p>Platform</p></a>
        <a href="/roadmap" class="flex min-h-6 items-center hover:underline"><p>Roadmap</p></a>
        <a href="/company" class="flex min-h-6 items-center hover:underline"><p>Company</p></a>
        <a href="/contact" class="flex min-h-6 items-center hover:underline"><p>Contact</p></a>
      </div>

      <div class="flex flex-col space-y-0.5 text-[14px] uppercase lg:flex-row lg:items-baseline lg:space-x-4">
        <a href="https://files.butane.dev/white-paper.pdf" class="flex min-h-6 items-center hover:underline">
          Whitepaper <SmallArrowUp svgStyles="ml-2" />
        </a>
        <a href="https://files.butane.dev/yellow-paper.pdf" class="flex min-h-6 items-center hover:underline">
          Yellowpaper <SmallArrowUp svgStyles="ml-2" />
        </a>
        <a href="https://docs.butane.dev/" class="flex min-h-6 items-center hover:underline"
          >Documentation <SmallArrowUp svgStyles="ml-2" />
        </a>
      </div>
    </div>

    <div class="mt-20 hidden lg-desktop:block">
      <div class="relative items-center justify-between overflow-hidden lg-desktop:flex">
        <div class="relative left-[-85px] top-[-50px]">
          <video
            {@attach deferVideo({ media: '(min-width: 1440px)' })}
            autoplay
            class="relative mt-[130px] scale-[1.4] scale-x-125"
            playsinline
            loop
            muted
            defaultmuted
            disableremoteplayback
            oncontextmenu={handleContextMenu}
            preload="none"
          >
            <source data-src="https://assets.butane.dev/footer_tail.webm" type="video/webm" />
            <source data-src="https://assets.butane.dev/footer_tail.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
    </div>

    <div class="z-[1] col-span-2 mt-20 block self-center lg-desktop:hidden">
      <div class="px-4">
        <h2
          class="w-[75vw] text-center font-cirka text-[9vw] leading-[95%] md:w-[70vw] md:text-[8vw] lg:w-[650px] lg:text-[76px]"
        >
          A decentralised synthetics platform built on Cardano
        </h2>

        <LaunchButton />
      </div>
    </div>

    <div class="absolute left-[27%] top-[20%] z-[1] hidden lg-desktop:block">
      <h2 class="w-[700px] text-center font-cirka text-[76px] leading-[66px]">
        A decentralised synthetics platform built on Cardano
      </h2>

      <LaunchButton />
    </div>

    <div class="z-10 flex-row-reverse justify-between self-center lg:mt-24 lg:flex lg:w-[95%]">
      <div
        class="z-10 my-12 flex items-center space-x-6 lg:my-0 lg:flex-row lg:items-baseline lg:space-x-8 lg:self-start"
      >
        <a href="https://discord.gg/pxJah7qnnu" target="_blank" rel="noreferrer" aria-label="Discord">
          <ButaneImage src="discord.png" layout="fixed" width={40} height={40} alt="discord" class="cursor-pointer" />
        </a>
        <a href="https://t.me/butaneprotocol" target="_blank" rel="noreferrer" aria-label="Telegram">
          <ButaneImage src="telegram.png" layout="fixed" width={40} height={40} alt="telegram" class="cursor-pointer" />
        </a>
        <a href="https://x.com/butaneprotocol" target="_blank" rel="noreferrer" aria-label="X">
          <ButaneImage src="twitter.png" layout="fixed" width={40} height={40} alt="twitter" class="cursor-pointer" />
        </a>
        <a href="https://forum.butane.dev/" target="_blank" rel="noreferrer" aria-label="Forum">
          <ButaneImage src="forum.png" layout="fixed" width={40} height={40} alt="forum" class="cursor-pointer" />
        </a>
      </div>

      <div
        class="z-10 mb-2 flex items-center justify-center space-x-6 font-graphik text-[14px] uppercase lg:flex-row lg:items-baseline lg:space-x-8 lg:self-end"
      >
        <p>©2024 BUTANE</p>
        <a href="https://files.butane.dev/terms-and-conditions.txt" target="_blank" class="hover:underline"
          >Terms of Service</a
        >
        <a href="/notices" class="hover:underline">Notices</a>
      </div>
    </div>

    <div class="sticky left-[200%] top-[110%] z-0 scale-[5] xl-tablet:top-[115%] lg-desktop:hidden">
      <video
        {@attach deferVideo({ media: '(max-width: 1439px)' })}
        autoplay
        class=" max-h-[150px] scale-[0.8] scale-x-105 object-contain xl-mobile:mt-2 xl-tablet:max-h-[200px] xl:max-h-[220px]"
        playsinline
        loop
        muted
        defaultMuted
        disableremoteplayback
        oncontextmenu={handleContextMenu}
        preload="none"
      >
        <source
          data-src="https://assets.butane.dev/footer_tail.webm"
          type="video/webm"
          class="mt-8 scale-[1.2] scale-x-105 object-contain"
        />
        <source
          data-src="https://assets.butane.dev/footer_tail.mp4"
          type="video/mp4"
          class="mt-8 scale-[1.2] scale-x-105 object-contain"
        />
      </video>
    </div>
  </div>

  <a href={pageLink} data-sveltekit-preload-code="eager" data-sveltekit-noscroll class="block cursor-pointer">
    <div
      class="m-2 mx-2 flex items-end justify-between rounded-lg bg-[#24CAFF] p-4 pb-6 pt-10 transition-all duration-300 hover:scale-[1.01] active:scale-[.99] lg-desktop:mx-4 lg-desktop:h-[280px]"
    >
      <div class="space-y-4 text-black sm-desktop:space-y-12">
        <p class="font-graphik uppercase">[ Next ]</p>
        <h2 class="row-start-2 font-cirka text-[40px] text-black sm-desktop:text-[92px]">
          {nextPage}
        </h2>
      </div>

      <div class="flex h-[40px] w-[72px] items-center justify-center rounded-full bg-black shadow-sm shadow-[#939EB8]">
        <ButtonArrowUpSvg svgStyles="scale-[1.7]" />
      </div>
    </div>
  </a>
</footer>
